import React from 'react';

const ProjectCard = ({ category, title, description, outcomes, color }) => (
  <div className="project-card">
    <div className="card-accent-bar" style={{ background: color }} />
    <div className="card-body-custom">
      <span className="category-badge">{category}</span>
      <h3>{title}</h3>
      <p>{description}</p>
      <div className="outcomes">
        {outcomes.map((o) => (
          <div key={o} className="outcome-item">
            <span className="bullet" />
            {o}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ProjectCard;
